import React from 'react';

import classNames from 'classnames';

import HubspotForm from '../../common/HubspotForm';
import NewsletterStyles from './Newsletter.module.scss';

interface INewsletter {
  data: {
    title?: string;
    formId: string;
    variant?: string;
  };
}

const Newsletter = ({ data: { title, formId, variant } }: INewsletter) => (
  <div
    className={classNames(NewsletterStyles.newsletter, {
      [NewsletterStyles[`newsletter_${variant}`]]: variant,
    })}
  >
    {title && <h3>{title}</h3>}
    <HubspotForm formId={formId} customCss={false} />
  </div>
);

export default Newsletter;
